import { render, staticRenderFns } from "./Createcoupon.vue?vue&type=template&id=13182586&scoped=true&"
import script from "./Createcoupon.vue?vue&type=script&lang=js&"
export * from "./Createcoupon.vue?vue&type=script&lang=js&"
import style0 from "./Createcoupon.vue?vue&type=style&index=0&id=13182586&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13182586",
  null
  
)

export default component.exports